function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "website-icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-20px-/-Laptop-/-enabled",
  transform: "translate(-1.000000, -3.000000)",
  stroke: "#00AEFF",
  strokeWidth: 0.888888889
}, /*#__PURE__*/React.createElement("g", {
  id: "website-icon",
  transform: "translate(2.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.33333333,8.55555556 L1.33333333,1.2962963 C1.33333333,0.580371621 1.930287,0 2.66666667,0 L13.3333333,0 C14.069713,0 14.6666667,0.580371621 14.6666667,1.2962963 L14.6666667,8.55555556",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1333333,10.1111111 L10.1333333,11.1481481 L5.86666667,11.1481481 L5.86666667,10.1111111 L0,10.1111111 C0,11.4074074 0.8,12.4444444 2.13333333,12.4444444 L13.8666667,12.4444444 C15.2,12.4444444 16,11.4074074 16,10.1111111 L10.1333333,10.1111111 Z",
  id: "Path"
}))));

var SvgWebsiteIcon = function SvgWebsiteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsiteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/website-icon.52230903.svg";
export { ForwardRef as ReactComponent };